if (!customElements.get('media-gallery-cylindo')) {
  customElements.define('media-gallery-cylindo', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        viewer: this.querySelector('.cylindo-viewer'),
        variants: document.querySelector('variant-radios, variant-selects')
      };
      this.settings = {
        'accountID': this.dataset.account,
        'productCode': this.dataset.productCode,
        'features': JSON.parse(this.dataset.productFeatures) || [],
        'background': this.dataset.background,
        'fallbackImage': this.dataset.fallbackImage,
        'containerID': this.elements.viewer.id,
        'size': window.devicePixelRatio > 1 ? 1024 : 'auto',
        'alternateContent': JSON.parse(atob(this.dataset.altMediaObject)),
        'startFrame': parseInt(this?.dataset?.startFrame || 1)
      };
    }

    connectedCallback() {
      if (this.isConnected) {
        this.initCylindo();
        this.attachEvents();
      } else {
        if (this.viewerInstance) {
          this.viewerInstance.destroy();
        }
      }
    }

    initCylindo() {
      if (window.cylindo) {
        window.cylindo.on('ready', this.onCylindoReady.bind(this));
      }
    }

    onCylindoReady() {
      this.viewerInstance = cylindo.viewer.create(this.settings);
    }

    attachEvents() {
      this.elements.variants.addEventListener('change', this.onVariantUpdate.bind(this));
    }

    onVariantUpdate(event) {
      if (this.elements.variants.currentVariant) {
        const newFeatures = this.getVariantData()[this.elements.variants.currentVariant.id] || [];
        this.updateDisplay(newFeatures);
      }
    }

    updateDisplay(newFeatures) {
      if (this.settings.features != newFeatures){
        this.settings.features = newFeatures;
        if (this.viewerInstance) {
          this.viewerInstance.setFeatures(newFeatures);
          this.preventStickyHeader();
          //this.elements.viewer.scrollIntoView({behavior: 'smooth'});
        }
      }
    }

    setActiveMedia(mediaId, prepend) {
      // This is an inherited method who's API must be maintained but we will not use it.
      // Cylindo needs data that we can only get from catching the change event on the selector.
      return;
    }


    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.elements.variants.querySelector('[type="application/json"][data-type="cylindo"]').textContent);
      return this.variantData;
    }
  });
}
